const LOCALE_MAP = {
  ar: "ar",
  es: "es-ES",
  fr: "fr-FR",
  hi: "hi-IN",
  id: "id-ID",
  it: "it-IT",
  ms: "ms-MY",
  pt: "pt-PT",
  ro: "ro-RO",
  tl: "fil-PH",
  tr: "tr-TR",
  vi: "vi-VN",
  "zh-cn": "zh-CN",
  "zh-hk": "zh-HK",
  "zh-tw": "zh-TW"
};
const DEFAULT_LOCALE = "en-US";
function resolveDatePickerLocale(locale) {
  if (!locale) return DEFAULT_LOCALE;
  const normalized = locale.trim();
  if (!normalized) return DEFAULT_LOCALE;
  const mapped = LOCALE_MAP[normalized.toLowerCase()];
  if (mapped) return mapped;
  return normalized;
}
export {
  resolveDatePickerLocale
};
//# sourceMappingURL=resolveDatePickerLocale.js.map
